import React from "react";

const VendorListItemsRFQ = ({ data }) => {
  return (
    <div>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "35%" }}>Particulars</th>
            <th style={{ width: "20%" }}>Delivery</th>
            <th style={{ width: "20%" }}>Unit</th>
            <th style={{ width: "20%" }}>Qty</th>
          </tr>
        </thead>
      </table>
      {data?.lineItems?.map((lineItem, index) => {
        return (
          <div key={index}>
            <div
              style={{
                width: "100%",
                display: "flex",
              }}
            >
              <span
                style={{
                  width: "5%",
                  borderBottom: lineItem?.notes ? "1px solid #181818" : "",
                  borderLeft: "1px solid #181818",
                  borderTop: "1px solid #181818",
                  paddingLeft: "3px",
                }}
              >
                {++index}
              </span>
              <span
                style={{
                  width: "35%",
                  borderBottom: lineItem?.notes ? "1px solid #181818" : "",
                  borderLeft: "1px solid #181818",
                  borderTop: "1px solid #181818",
                  paddingLeft: "3px",
                }}
              >
                {lineItem?.particulars}
              </span>
              <span
                style={{
                  width: "20%",
                  borderBottom: lineItem?.notes ? "1px solid #181818" : "",
                  borderLeft: "1px solid #181818",
                  borderTop: "1px solid #181818",
                  paddingLeft: "3px",
                }}
              >
                {lineItem?.deliveryDate || "N/A"}
              </span>
              <span
                style={{
                  width: "20%",
                  borderBottom: lineItem?.notes ? "1px solid #181818" : "",
                  borderLeft: "1px solid #181818",
                  borderTop: "1px solid #181818",
                  paddingLeft: "3px",
                }}
              >
                {lineItem?.itemUnit.toUpperCase() || "N/A"}
              </span>
              <span
                style={{
                  width: "20%",
                  borderBottom: lineItem?.notes ? "1px solid #181818" : "",
                  borderLeft: "1px solid #181818",
                  borderRight: "1px solid #181818",
                  borderTop: "1px solid #181818",
                  paddingLeft: "3px",
                }}
              >
                {lineItem?.itemQuantity}
              </span>
            </div>

            {lineItem?.notes && (
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  // margin: "20px",
                  fontSize: "15px",
                  padding: "10px",
                  border: "1px solid black",
                }}
              >
                <p style={{ fontWeight: "bold" }}>Notes:</p>
                <p>
                  {lineItem?.notes
                    .trim()
                    .split("\n")
                    .map((line, index) => (
                      <b key={index}>
                        {line}
                        {index !== lineItem?.notes.split("\n").length - 1 && (
                          <br />
                        )}
                      </b>
                    ))}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default VendorListItemsRFQ;
